// extracted by mini-css-extract-plugin
module.exports = {"roid01":"roid01-module--roid01--96w_y","container":"roid01-module--container--2mIkJ"};